import { Vector3 as n, Box3 as f, OrthographicCamera as g, MathUtils as u } from "three";
function y({
  camera: t,
  canvas: s,
  building: h,
  direction: p,
  expand: r = new n(10, 5, 10)
}) {
  const x = h.children.map((e) => new n(...e.pos)), o = new f().setFromPoints(x);
  o.expandByVector(r);
  const i = o.getSize(new n()), l = o.getCenter(new n());
  if (t instanceof g)
    t = t, t.zoom = Math.min(s.width / i.x, s.height / i.y * 0.4), t.position.copy(p).negate().multiplyScalar(500), t.updateProjectionMatrix(), t.updateMatrix();
  else {
    t = t;
    const e = i.length() * 0.5, d = u.DEG2RAD * t.fov * 0.5, c = e / Math.tan(d);
    t.position.copy(p).multiplyScalar(-c).add(l);
  }
  return t.lookAt(l), o;
}
export {
  y as FrameCamToBuilding
};
//# sourceMappingURL=index12.js.map
